import React, { Component } from "react";

export function initNetlifyIdentity() {
  console.log('initNetlifyIdentity() called');
  const script = document.createElement("script");

  script.src = "https://identity.netlify.com/v1/netlify-identity-widget.js";
  script.async = true;

  document.body.appendChild(script);
}

export function openNetlifyModal() {
  if(getNetlifyIdentity())
    getNetlifyIdentity().open();
  else
    console.log('called openNetlifyModal() before netlifyIdentity has been set.')
}

export function getNetlifyIdentity() {
  console.log('GET NETLIFY IDENTITY CALLEDS')
  const netlifyIdentity = window.netlifyIdentity;

  if(netlifyIdentity)
    return(netlifyIdentity)
  else
    console.log('called getNetlifyIdentity() before netlifyIdentity has been set.')
}

export function getUser() {
  if(getNetlifyIdentity())
    return getNetlifyIdentity().currentUser() 
  else
    return undefined
}

//For initializing the netlify identity scripts.
//=============================================================
//it is necessary because `document` will not be defined at compile time
//for a static site.
export default class NetlifyIdentity extends Component {
  componentDidMount() {
    initNetlifyIdentity();
  }

  render() {
    return(<div></div>)
  }
}

